import { render, staticRenderFns } from "./ComposeWebmail.vue?vue&type=template&id=6fd0374c&scoped=true&"
import script from "./ComposeWebmail.vue?vue&type=script&lang=js&"
export * from "./ComposeWebmail.vue?vue&type=script&lang=js&"
import style0 from "./ComposeWebmail.vue?vue&type=style&index=0&id=6fd0374c&scoped=true&lang=css&"
import style1 from "./ComposeWebmail.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fd0374c",
  null
  
)

export default component.exports